﻿import React, { useState, useEffect } from 'react';
import { LookupItem } from '../../models/lookup-item';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';

import DataGrid, {
    Column,
    FilterRow,
    GroupPanel,
    Selection,
    HeaderFilter,
    Editing,
    Popup,
    Form,
    Toolbar,
    Item as ToolbarItem,
    Button as ColumnButton,
    Paging,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Item } from 'devextreme-react/form';

export interface Props {
    title: string;
}

export default function VmiGroupsManagementForm(props: Props) {
    const [vmiGroups, setVmiGroups] =
        useState<LookupItem[]>();

    const [toastVisible, setToastVisible] =
        useState<boolean>();

    const [toastMessage, setToastMessage] =
        useState<string>();

    const [toastType, setToastType] =
        useState<any>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getVendors();
    }, []);

    return (
        <div>
            <DataGrid 
                height="65vh"
                keyExpr="id"
                dataSource={vmiGroups ? vmiGroups : []}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnResizingMode='widget'
                onRowValidating={onVmiGroupRowValidating}
                rowAlternationEnabled={true}
                showRowLines={true}
                showBorders={true} >

                <LoadPanel enabled={true} />
                <Paging enabled={false} />
                <Selection mode='single' />
                <HeaderFilter visible={true} />
                <FilterRow visible={true} />
                <GroupPanel visible={false} />
                <SearchPanel visible={true} />
                <Scrolling columnRenderingMode='virtual' />

                <Column type="buttons" width={"5rem"}>
                    <ColumnButton name="edit" />
                </Column>

                <Column dataField='name' width='18rem' dataType="string" />
                <Column dataField='description' dataType="string" />

                <Toolbar>
                    <ToolbarItem location='before'>
                        <div className="pw-datagrid-toolbar-template">
                            <div className="pw-datagrid-toobar-title">{props.title}</div>
                        </div>
                    </ToolbarItem>
                    <ToolbarItem name="addRowButton" location='after' />
                    <ToolbarItem name="searchPanel" location='after' />
                </Toolbar>

                <Editing
                    mode="popup"
                    useIcons={true}
                    allowAdding={true}
                    allowUpdating={true}
                    allowDeleting={false} >

                    <Popup title={props.title} showTitle={true} width='80vw' height='80vh' />
                    <Form>
                        <Item dataField="name" colSpan={2} />
                        <Item dataField="description" colSpan={2} />
                    </Form>

                </Editing>
            </DataGrid >

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    async function onVmiGroupRowValidating(e: any) {
        if (e.oldData) {
            let vmiGroup = e.oldData as LookupItem;

            if (vmiGroup) {
                let updatedVmiGroup = { ...vmiGroup, ...e.newData };

                await updateVmiGroup(updatedVmiGroup)
                    .then(() => {
                        showToast("VMI Group updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating VMI Group");
                    });
            }
        }
        else {
            if (e.newData) {
                let vmiGroup = e.newData as LookupItem;

                if (vmiGroup) {
                    await insertVmiGroup(vmiGroup)
                        .then(data => {
                            showToast("VMI Group saved", "success");
                            getVendors();
                        })
                        .catch(res => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting VMI Group");
                        });
                }
            }
        }
    }

    async function getVendors() {
        await CrudFunctions.getData("common/vmigroups")
            .then((data) => {
                setVmiGroups(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving VMI Groups");
            });
    }

    async function insertVmiGroup(vmiGroup: LookupItem) {
        return await CrudFunctions.postData("common/vmigroup", vmiGroup)
    }

    async function updateVmiGroup(vmiGroup: LookupItem) {
        return await CrudFunctions.putData("common/vmiGroup", vmiGroup)
    }

    //show/hide

    function onToastHiding() {
        setToastVisible(false);
        setToastMessage(undefined);
        setToastType(undefined);
    }

    function showToast(message: string, toastType: string) {
        setToastMessage(message);
        setToastType(toastType);
        setToastVisible(true);
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

